export default __webpack_public_path__ + "static/funcionamiento-icono-4-d03a5445f57d08bc36ad628ed1b6922e.png";